import { DistanceCalculator } from 'ts/components/DistanceCalculator/index.ts';

const distanceCalc = new DistanceCalculator();

const latLngFromPoint = (pt) => {
  return {
    latitude: typeof pt.lat == "function" ? pt.lat() : pt.lat,
    longitude: typeof pt.lng == "function" ? pt.lng() : pt.lng
  };
}

export class PanButton {
  constructor(buttonAction, options) {
    this.buttonAction = buttonAction || (() => {});

    options = options || {};
    this.buttonClass = options.buttonClass || 'js-pan-button';
    this.buttonText = options.buttonText || 'search this area';
    this.distanceThreshold = options.distanceThreshold || 5;

    this.button = this.createButton();
  };

  addToMap(map, parent) {
    if (!(map && parent)) { return; };

    this.map = map.map;
    this.parent = parent;
    this.parent.appendChild(this.button);

    if (map.config.provider == 'Google') {
      this.map.addListener('dragend', this.dragHandler.bind(this));
    } else {
      this.map.on('dragend', this.dragHandler.bind(this));
    }
  }

  dragHandler() {
    if (!this.previousCenter) {
      this.previousCenter = this.map.getCenter();
    }
    const currentCenter = this.map.getCenter();
    const distance = distanceCalc.haversineDistance(latLngFromPoint(this.previousCenter), latLngFromPoint(currentCenter));
    if (distance > this.distanceThreshold) {
      this.showButton();
    }
  }

  showButton() {
    this.button.classList.add('is-visible');
    this.button.classList.remove('is-hidden');
  }

  hideButton() {
    this.button.classList.remove('is-visible');
    this.button.classList.add('is-hidden');
  }

  createButton() {
    const button = document.createElement('button');
    button.innerHTML = this.buttonText;
    button.classList.add(this.buttonClass);
    button.classList.add('is-hidden');

    button.addEventListener('click', () => {
      let currentCenter = this.map.getCenter();
      this.previousCenter = currentCenter;

      this.buttonAction(this.map, latLngFromPoint(currentCenter));
      this.hideButton();
    });


    return button;
  }
}
